import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCalendarAlt, faTruck, faUser, faMapMarkerAlt, faPlus, 
  faTh, faBell, faQuestionCircle, faChartBar, faChartLine, 
  faChartArea, faRoad, faTachometerAlt, faGasPump, faClipboardList, 
  faCalendarDay, faClipboardCheck, faExclamationTriangle,
  faShieldAlt, faFileAlt, faCarAlt, faRoute, faMapMarked,
  faSearch, faAngleLeft, faAngleRight, faRightFromBracket,
  faQuestion, faInfo,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import TrackMap from './TrackMap';
import TrackReport from './trackreport/TrackReport';
import FolderList from '../folders/FolderList';
import './ReportStyles.css';
import logo from '../../images/logo.svg';
import fuel from '../../images/fuel.png';
import track from '../../images/road.png';
import track2 from '../../images/tracks.png';
import ChartDebugPanel from './ChartDebugPanel'; 
import { saveDateRangeToLocalStorage } from '../../utils/DateUtils';
import StatisticsReport from './StatisticsReport';
import CommonStatReport from './CommonStatReport';

const LiveTrack = ({ vehicle, startDate, endDate }) => (
  <div className="component-placeholder">
    <h3>Компонент LiveTrack находится в разработке</h3>
    <p>Выбрано ТС: {vehicle?.name || 'Не выбрано'}</p>
    <p>Период: {startDate?.toLocaleDateString()} - {endDate?.toLocaleDateString()}</p>
  </div>
);


import SpeedChart from './SpeedChart';
import FuelChart from './FuelChart';
import VoltageChart from './VoltageChart';
import EngineChart from './EngineChart';


import '../../utils/SplitScreen.css';
import ReportSelector from './ReportSelector';

const ReportsPage = () => {
  const [dateRange, setDateRange] = useState(() => {
    
    try {
      const savedRange = localStorage.getItem('lastDateRange');
      if (savedRange) {
        const parsed = JSON.parse(savedRange);
        
        return {
          startDate: parsed.startDate ? new Date(parsed.startDate) : new Date(),
          endDate: parsed.endDate ? new Date(parsed.endDate) : new Date()
        };
      }
    } catch (e) {
      console.warn('Ошибка при чтении диапазона дат из localStorage:', e);
    }
    
    
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 1);
    return { startDate: start, endDate: end };
  });
  const [selectedPeriod, setSelectedPeriod] = useState('today');
  const [stats, setStats] = useState({ vehicles: 0, drivers: 0, trips: 0 });
  const [openTabs, setOpenTabs] = useState([]);
  const [activeTabId, setActiveTabId] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [showReportMenu, setShowReportMenu] = useState(false);

  
  const [previewReport, setPreviewReport] = useState({
    title: 'Выберите отчет',
    description: 'Наведите курсор на интересующий вас отчет, чтобы увидеть его описание.',
    image: ''
  });

  
  
  const datePickerRef = useRef(null);
  const reportMenuRef = useRef(null);

  
  const [isCompactMode, setIsCompactMode] = useState(false);
  
  
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  
  
  const profileMenuRef = useRef(null);

  
  const [splitMode, setSplitMode] = useState(() => {
    const savedMode = localStorage.getItem('splitScreenMode');
    return savedMode || 'single';  
  });

  
  const [showDateModal, setShowDateModal] = useState(false);
  const [tempStartDate, setTempStartDate] = useState('');
  const [tempEndDate, setTempEndDate] = useState('');

  
  const [splitScreenActive, setSplitScreenActive] = useState(false);
  
  
  const reportsContainerRef = useRef(null);

  
  useEffect(() => {
    // Обработчик события создания отчета
    const handleCreateReport = (event) => {
      const { reportType, container, vehicle, startDate, endDate } = event.detail;
      
      // Создаем отчет для указанного контейнера
      createReportForContainer(reportType, container, vehicle, startDate, endDate);
    };

    // Обработчик события создания отчета в контейнере (для разделенного экрана)
    const handleCreateReportInContainer = (event) => {
      const { reportType, containerId, vehicle, startDate, endDate } = event.detail;
      
      console.log('ReportsPage: Получено событие createReportInContainer:', {
        reportType,
        containerId,
        vehicle: vehicle?.name,
        startDate,
        endDate
      });
      
      // Создаем отчет для указанного контейнера
      createReportForContainer(reportType, containerId, vehicle, startDate, endDate);
    };
    
    // Подписываемся на события
    document.addEventListener('createReport', handleCreateReport);
    document.addEventListener('createReportInContainer', handleCreateReportInContainer);
    
    // Отписываемся при размонтировании
    return () => {
      document.removeEventListener('createReport', handleCreateReport);
      document.removeEventListener('createReportInContainer', handleCreateReportInContainer);
    };
  }, []);

  
  useEffect(() => {
    const handleBeforeUnload = () => {
      console.log('ReportsPage: Обработка события beforeunload');
      
      
      const reportChoosers = document.querySelectorAll('.report-chooser-overlay');
      reportChoosers.forEach(element => {
        try {
          if (element.parentNode) {
            element.parentNode.removeChild(element);
          }
        } catch (e) {
          console.error('Ошибка при удалении модального окна перед выгрузкой:', e);
        }
      });
      
      
      const modalRoot = document.getElementById('modal-root');
      if (modalRoot) {
        while (modalRoot.firstChild) {
          modalRoot.removeChild(modalRoot.firstChild);
        }
      }
    };
    
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      handleBeforeUnload(); 
    };
  }, []);

  
  const formatDate = (date) => {
    if (!date) return '';
    
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    
    if (!(dateObj instanceof Date) || isNaN(dateObj)) {
      console.warn('Невалидная дата для форматирования:', date);
      return '';
    }
    
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${day}.${month}.${year}`;
  };

  
  const calculateDateRange = (baseDate, periodType) => {
    const currentDate = baseDate || new Date();
    const startDate = new Date(currentDate);
    const endDate = new Date(currentDate);

    if (periodType === 'day') {
      startDate.setDate(startDate.getDate() -1);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
    } else if (periodType === 'week') {
      endDate.setDate(startDate.getDate());
      startDate.setDate(startDate.getDate() - 7);
      startDate.setHours(0, 0, 0, 0);
    } else if (periodType === 'month') {
      endDate.setDate(startDate.getDate());
      startDate.setDate(startDate.getDate() - 31);
      startDate.setHours(0, 0, 0, 0);
    }

    return { startDate, endDate };
  };

  
  useEffect(() => {
    const savedPeriod = localStorage.getItem('currentPeriodType') || 'day';
    setSelectedPeriod(savedPeriod);
    const { startDate, endDate } = calculateDateRange(new Date(), savedPeriod);
    setDateRange({ startDate, endDate });
    
    
    fetchStatistics();
  }, []);

  
  const handleCalendarClick = () => {
    
    const startDate = dateRange.startDate instanceof Date 
      ? dateRange.startDate.toISOString().split('T')[0] 
      : (typeof dateRange.startDate === 'string' ? dateRange.startDate : '');
      
    const endDate = dateRange.endDate instanceof Date 
      ? dateRange.endDate.toISOString().split('T')[0] 
      : (typeof dateRange.endDate === 'string' ? dateRange.endDate : '');
    
    setTempStartDate(startDate);
    setTempEndDate(endDate);
    
    setShowDateModal(true);
  };

  
  const closeDateModal = () => {
    setShowDateModal(false);
  };

  
  const handleStartDateChange = (e) => {
    setTempStartDate(e.target.value);
  };

  
  const handleEndDateChange = (e) => {
    setTempEndDate(e.target.value);
  };

  
  const applyDateRange = () => {
    if (!tempStartDate || !tempEndDate) {
      alert('Пожалуйста, выберите дату начала и окончания');
      return;
    }

    // Копируем даты, чтобы не изменять оригинальные объекты
    const startDate = new Date(tempStartDate);
    const endDate = new Date(tempEndDate);
    
    // Устанавливаем время для начальной даты (начало дня)
    startDate.setHours(0, 0, 0, 0);
    
    // Устанавливаем время для конечной даты (конец дня)
    endDate.setHours(23, 59, 59, 999);

    setDateRange({ startDate, endDate });
    
    // Используем утилиту для сохранения данных в localStorage
    const updateTimestamp = saveDateRangeToLocalStorage(startDate, endDate, 'custom');
    
    // Закрываем модальное окно
    setShowDateModal(false);
    
    // Отправляем событие изменения дат
    const event = new CustomEvent('dateRangeChanged', {
      detail: {
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
        periodType: 'custom',
        forceUpdate: true,
        timestamp: updateTimestamp
      }
    });
    document.dispatchEvent(event);
    
    // Обновляем все открытые отчеты
    const forceUpdateEvent = new CustomEvent('forceVehicleUpdate', {
      detail: { 
        vehicle: selectedVehicle,
        startDate: startDate,
        endDate: endDate,
        timestamp: updateTimestamp
      }
    });
    document.dispatchEvent(forceUpdateEvent);
    
    // Обновляем вкладки
    if (openTabs.length > 0) {
      setOpenTabs(prevTabs => prevTabs.map(tab => ({
        ...tab,
        startDate: startDate,
        endDate: endDate
      })));
    }
  };

  
  const handlePeriodChange = (period) => {
    setSelectedPeriod(period);
    localStorage.setItem('currentPeriodType', period);
    
    const { startDate, endDate } = calculateDateRange(new Date(), period);
    
    startDate.setHours(0, 0, 0, 0);
    
    setDateRange({ startDate, endDate });
    
    // Используем утилиту для сохранения данных в localStorage
    const updateTimestamp = saveDateRangeToLocalStorage(startDate, endDate, period);
    
    console.log('Сохранены даты в localStorage:', {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      periodType: period
    });
    
    const event = new CustomEvent('dateRangeChanged', {
      detail: {
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
        periodType: period,
        forceUpdate: true,
        timestamp: updateTimestamp
      }
    });
    document.dispatchEvent(event);
    
    const forceUpdateEvent = new CustomEvent('forceVehicleUpdate', {
      detail: { 
        vehicle: selectedVehicle,
        startDate: startDate,
        endDate: endDate,
        timestamp: updateTimestamp
      }
    });
    document.dispatchEvent(forceUpdateEvent);
    
    if (openTabs.length > 0) {
      setOpenTabs(prevTabs => prevTabs.map(tab => ({
        ...tab,
        startDate: startDate,
        endDate: endDate
      })));
    }
  };

  
  const fetchStatistics = async () => {
    try {
      
      const getJwtToken = () => {
        
        const possibleTokenKeys = ['authToken', 'token', 'jwt', 'access_token'];
        
        for (const key of possibleTokenKeys) {
          const token = localStorage.getItem(key);
          if (token) {
            
            if (token.split('.').length === 3) {
              return token;
            }
          }
        }
        
        
        const header = btoa(JSON.stringify({ alg: 'HS256', typ: 'JWT' }));
        const payload = btoa(JSON.stringify({ 
          sub: 'test-user', 
          name: 'Test User', 
          role: 'ADMIN',
          exp: Math.floor(Date.now() / 1000) + 3600 
        }));
        const signature = btoa('test-signature');
        
        return `${header}.${payload}.${signature}`;
      };
      
      const token = getJwtToken();
      
      
      console.log('Попытка загрузки статистики:');
      console.log('URL:', '/admin/statistics');
      
      
      const tokenParts = token.split('.');
      const tokenForLog = tokenParts.length === 3 
                        ? `${tokenParts[0].substring(0, 10)}...` 
                        : token;
      console.log('Заголовки:', {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${tokenForLog}`
      });
      
    } catch (error) {
      console.error('Ошибка при загрузке статистики:', error);
      
      setStats({ vehicles: 0, drivers: 0, trips: 0 });
    }
  };

  
  const handleAddReportClick = () => {
    setShowReportMenu(!showReportMenu);
  };

  
  const handleReportSelect = (reportType) => {
    if (!selectedVehicle) {
      alert('Пожалуйста, выберите транспортное средство для создания отчета');
      return;
    }
    
    // Добавляем отладочное логирование
    console.log('Создание отчета:', {
      type: reportType,
      vehicle: selectedVehicle,
      startDate: dateRange.startDate ? dateRange.startDate.toISOString() : 'не указана',
      endDate: dateRange.endDate ? dateRange.endDate.toISOString() : 'не указана'
    });
    
    const tabId = `tab-${Date.now()}`;
    
    const newTab = {
      id: tabId,
      type: reportType,
      vehicle: selectedVehicle,
      title: getReportTitle(reportType),
      startDate: dateRange.startDate,
      endDate: dateRange.endDate
    };
    
    setOpenTabs(prevTabs => [...prevTabs, newTab]);
    setActiveTabId(tabId);
    setShowReportMenu(false);
  };

  
  const getReportTitle = (reportType) => {
    switch (reportType) {
      case 'track': return 'Трек';
      case 'live-track': return 'Местоположение';
      case 'speed': return 'Скорость';
      case 'fuel': return 'Объем топлива';
      case 'voltage': return 'Напряжение';
      case 'rpm': return 'Обороты двигателя';
      case 'statistics': return 'Статистика';
      case 'common_stat': return 'Сводный отчет';
      case 'safedrive-details': return 'SafeDrive: Детализация нарушений';
      case 'safedrive-rating': return 'SafeDrive: Рейтинг водителей';
      case 'fuel-sheet': return 'Ведомость топливозаправщика';
      case 'fuel-delivery': return 'Выдача топлива';
      case 'fuel-operations': return 'Выдачи, заливы и сливы топлива';
      case 'routes': return 'Выполнение рейсов';
      case 'movement': return 'Движение';
      case 'journal': return 'Журнал';
      case 'fuel-consumption': return 'Расход топлива';
      case 'mileage-report': return 'Отчет по пробегу';
      case 'driver-performance': return 'Производительность водителей';
      case 'vehicle-maintenance': return 'Техобслуживание';
      case 'violations-report': return 'Отчет по нарушениям';
      case 'efficiency-report': return 'Отчет по эффективности';
      case 'cost-analysis': return 'Анализ затрат';
      case 'time-analysis': return 'Анализ времени';
      case 'geofence-report': return 'Отчет по геозонам';
      case 'alert-report': return 'Отчет по уведомлениям';
      case 'custom-report': return 'Пользовательский отчет';
      default: return 'Отчет';
    }
  };

  
  const getReportIcon = (reportType) => {
    switch (reportType) {
      case 'track': return 'fas fa-route';
      case 'live-track': return 'fas fa-location-arrow';
      case 'fuel': return 'fas fa-gas-pump';
      case 'speed': return 'fas fa-tachometer-alt';
      case 'safedrive-details': return 'fas fa-shield-alt';
      case 'safedrive-rating': return 'fas fa-shield-alt';
      case 'fuel-sheet': return 'fas fa-clipboard-list';
      case 'fuel-delivery': return 'fas fa-gas-pump';
      case 'fuel-operations': return 'fas fa-gas-pump';
      case 'routes': return 'fas fa-road';
      case 'movement': return 'fas fa-car-alt';
      case 'journal': return 'fas fa-file-alt';
      case 'fuel-consumption': return 'fas fa-gas-pump';
      case 'mileage-report': return 'fas fa-road';
      case 'driver-performance': return 'fas fa-user';
      case 'vehicle-maintenance': return 'fas fa-truck';
      case 'violations-report': return 'fas fa-exclamation-triangle';
      case 'efficiency-report': return 'fas fa-chart-line';
      case 'cost-analysis': return 'fas fa-chart-bar';
      case 'time-analysis': return 'fas fa-clock';
      case 'geofence-report': return 'fas fa-map-marker-alt';
      case 'alert-report': return 'fas fa-bell';
      case 'custom-report': return 'fas fa-file-alt';
      case 'voltage': return 'fas fa-bolt';
      case 'rpm': return 'fas fa-cog';
      case 'statistics': return 'fas fa-chart-bar';
      case 'common_stat': return 'fas fa-chart-bar';
      default: return 'fas fa-file-alt';
    }
  };

  
  const handleCloseTab = (tabId, e) => {
    e.stopPropagation();
    
    setOpenTabs(prevTabs => {
      const filteredTabs = prevTabs.filter(tab => tab.id !== tabId);
      
      
      if (activeTabId === tabId && filteredTabs.length > 0) {
        setActiveTabId(filteredTabs[filteredTabs.length - 1].id);
      } else if (filteredTabs.length === 0) {
        setActiveTabId(null);
      }
      
      return filteredTabs;
    });
  };

  
  const handleTabChange = (tabId) => {
    setActiveTabId(tabId);
  };

  
  const handleVehicleSelect = (vehicle) => {
    
    if (selectedVehicle && vehicle && selectedVehicle.id === vehicle.id) {
      console.log('Выбрано то же самое ТС, игнорируем:', vehicle?.name);
      return;
    }

    setSelectedVehicle(vehicle);
    console.log('Выбрано транспортное средство:', vehicle);

    
    window.lastSelectedVehicleId = vehicle?.id;
    window.lastVehicleUpdateTime = new Date().getTime();

    
    
    const forceUpdateEvent = new CustomEvent('forceVehicleUpdate', {
      detail: { 
        vehicle: vehicle,
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
        timestamp: window.lastVehicleUpdateTime
      }
    });

    
    document.dispatchEvent(forceUpdateEvent);

    
    if (vehicle && openTabs.length > 0) {
      setOpenTabs(prevTabs => prevTabs.map(tab => ({
        ...tab,
        vehicle: vehicle
      })));
    }
  };

  
  const renderActiveTabContent = () => {
    const activeTab = openTabs.find(tab => tab.id === activeTabId);
    
    if (!activeTab) {
      return (
        <div className="default-dashboard active">
          <div className="dashboard-sections">
            <div className="dashboard-section">
              <h2>Популярные:</h2>
              <div className="dashboard-cards">
                <div className="dashboard-card" onClick={() => handleReportSelect('track')}>
                  <div className="card-title">Трек</div>
                  <div className="card-content">
                    <img src={track2} alt="Трек" />
                  </div>
                </div>
                <div className="dashboard-card" onClick={() => handleReportSelect('live-track')}>
                  <div className="card-title">Местоположение</div>
                  <div className="card-content">
                    <img src={track} alt="Местоположение" />
                  </div>
                </div>
                <div className="dashboard-card" onClick={() => handleReportSelect('statistics')}>
                  <div className="card-title">Статистика</div>
                  <div className="card-content">
                    <img src={track} alt="Статистика" />
                  </div>
                </div>
                <div className="dashboard-card" onClick={() => handleReportSelect('common_stat')}>
                  <div className="card-title">Сводный отчет</div>
                  <div className="card-content">
                    <img src={track} alt="Сводный отчет" />
                  </div>
                </div>
                <div className="dashboard-card" onClick={() => handleReportSelect('fuel')}>
                  <div className="card-title">Заправки и сливы</div>
                  <div className="card-content">
                    <img src={fuel} alt="Заправки и сливы" />
                  </div>
                </div>

                

              </div>
            </div>
            
            <div className="dashboard-section">
              <h2>Рабочие столы:</h2>
              <div className="dashboard-cards">
                <div className="dashboard-card">
                  <div className="card-title">Рабочий стол Руководителя</div>
                  <div className="card-content">
                    <img src={track} alt="Рабочий стол Руководителя" />
                  </div>
                </div>
                <div className="dashboard-card">
                  <div className="card-title">Трек + Объём топлива</div>
                  <div className="card-content">
                    <img src={track} alt="Трек + Объём топлива" />
                  </div>
                </div>
                <div className="dashboard-card">
                  <div className="card-title">Трек + Скорость</div>
                  <div className="card-content">
                    <img src={track} alt="Трек + Скорость" />
                  </div>
                </div>
                <div className="dashboard-card">
                  <div className="card-title">Трек + Статистика</div>
                  <div className="card-content">
                      <img src={track} alt="Трек + Статистика" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    
    
    const tabStartDate = activeTab.startDate || dateRange.startDate;
    const tabEndDate = activeTab.endDate || dateRange.endDate;
    
    
    console.log('Отображение отчета (одно сообщение):', {
      type: activeTab.type,
      vehicle: activeTab.vehicle,
      startDate: tabStartDate ? tabStartDate.toISOString() : 'не указана',
      endDate: tabEndDate ? tabEndDate.toISOString() : 'не указана'
    });
    
    
    const forceUpdateEvent = new CustomEvent('forceVehicleUpdate', {
      detail: { 
        vehicle: activeTab.vehicle,
        startDate: tabStartDate,
        endDate: tabEndDate,
        timestamp: new Date().getTime() 
      }
    });
    
    
    setTimeout(() => document.dispatchEvent(forceUpdateEvent), 50);
    
    
    switch (activeTab.type) {
      case 'track':
        return (
          <TrackReport
            key={`track-${activeTab.id}-${activeTab.vehicle?.id || 'no-vehicle'}-${Date.now()}`}
            tabId={activeTab.id} 
            vehicle={activeTab.vehicle} 
            startDate={tabStartDate} 
            endDate={tabEndDate}
            hidePeriodSelector={true}
          />
        );
      case 'live-track':
        return (
          <LiveTrack
            vehicle={activeTab.vehicle}
            startDate={tabStartDate}
            endDate={tabEndDate}
          />
        );
      case 'speed':
        return (
          <SpeedChart 
            vehicle={activeTab.vehicle} 
            startDate={tabStartDate} 
            endDate={tabEndDate}
          />
        );
      case 'fuel':
        return (
          <FuelChart 
            vehicle={activeTab.vehicle} 
            startDate={tabStartDate} 
            endDate={tabEndDate}
          />
        );
      case 'voltage':
        return (
          <VoltageChart 
            vehicle={activeTab.vehicle} 
            startDate={tabStartDate} 
            endDate={tabEndDate}
          />
        );
      case 'rpm':
        return (
          <EngineChart
            vehicle={activeTab.vehicle}
            startDate={tabStartDate}
            endDate={tabEndDate}
          />
        );
      case 'statistics':
        return (
          <StatisticsReport
            key={`statistics-${activeTab.id}-${activeTab.vehicle?.id || 'no-vehicle'}-${Date.now()}`}
            vehicle={activeTab.vehicle}
            startDate={tabStartDate}
            endDate={tabEndDate}
          />
        );
      case 'common_stat':
        return (
          <CommonStatReport
            key={`common_stat-${activeTab.id}-${activeTab.vehicle?.id || 'no-vehicle'}-${Date.now()}`}
            vehicle={activeTab.vehicle}
            startDate={tabStartDate}
            endDate={tabEndDate}
          />
        );
      default:
        return (
          <div className="report-placeholder">
            <h3>Отчет в разработке</h3>
            <p>Выбранный тип отчета скоро будет доступен</p>
          </div>
        );
    }
  };

  
  const closeReportMenu = () => {
    setShowReportMenu(false);
  };

  
  useEffect(() => {
    
    const reportMenuPopup = reportMenuRef.current;
    const addReportBtn = document.querySelector('.add-report-btn');
    
    if (showReportMenu && reportMenuPopup && addReportBtn) {
      
      let timeoutId = null;
      
      const handleMouseEnter = () => {
        clearTimeout(timeoutId);
      };
      
      const handleMouseLeave = () => {
        timeoutId = setTimeout(() => {
          closeReportMenu();
        }, 300); 
      };
      
      
      reportMenuPopup.addEventListener('mouseenter', handleMouseEnter);
      reportMenuPopup.addEventListener('mouseleave', handleMouseLeave);
      addReportBtn.addEventListener('mouseenter', handleMouseEnter);
      addReportBtn.addEventListener('mouseleave', handleMouseLeave);
      
      
      return () => {
        reportMenuPopup.removeEventListener('mouseenter', handleMouseEnter);
        reportMenuPopup.removeEventListener('mouseleave', handleMouseLeave);
        addReportBtn.removeEventListener('mouseenter', handleMouseEnter);
        addReportBtn.removeEventListener('mouseleave', handleMouseLeave);
      };
    }
  }, [showReportMenu]);

  
  const getReportDescription = (reportType) => {
    switch (reportType) {
      case 'safedrive-details': 
        return 'Детальный отчет о нарушениях SafeDrive с указанием даты, времени, местоположения и типа нарушения.';
      case 'track': 
        return 'Визуализация маршрута движения транспортного средства на карте с отметками остановок и событий.';
      case 'live-track': 
        return 'Отслеживание транспортного средства в реальном времени с обновлением положения и телеметрических данных.';
      case 'fuel': 
        return 'График изменения уровня топлива с отметками заправок, сливов и расхода.';
      case 'speed': 
        return 'График скорости движения транспорта с выделением нарушений скоростного режима.';
      case 'voltage': 
        return 'График изменения напряжения бортовой сети транспортного средства.';
      case 'rpm': 
        return 'График оборотов двигателя транспортного средства с анализом нагрузки.';
      case 'statistics':
        return 'Подробная статистика по пробегу, времени движения, скорости и другим параметрам транспортного средства.';
      case 'common_stat':
        return 'Сводный отчет, содержащий основные показатели и статистику по всем доступным отчетам.';
      case 'safedrive-rating':
        return 'Рейтинг водителей на основе показателей безопасности и соблюдения правил SafeDrive.';
      case 'fuel-sheet':
        return 'Ведомость топливозаправщика, включающая информацию о заправках, сливах и расходах топлива.';
      case 'fuel-delivery':
        return 'Отчет по выдаче топлива, включающий данные о количестве, объеме и стоимости выданного топлива.';
      case 'fuel-operations':
        return 'Отчет по выдачам, заливам и сливам топлива, позволяющий анализировать операции с топливом.';
      case 'routes':
        return 'Отчет по выполнению рейсов, включающий информацию о маршрутах, времени и расстоянии.';
      case 'movement':
        return 'Отчет по движению транспортных средств, позволяющий анализировать маршруты и события.';
      case 'journal':
        return 'Журнал событий, включающий все значимые события и изменения в системе.';
      case 'fuel-consumption':
        return 'Отчет по расходу топлива, позволяющий анализировать эффективность и оптимизировать потребление.';
      case 'mileage-report':
        return 'Отчет по пробегу транспортных средств, включающий данные о пройденном расстоянии и средней скорости.';
      case 'driver-performance':
        return 'Отчет по производительности водителей, позволяющий оценить их эффективность и поведение за определенный период.';
      case 'vehicle-maintenance':
        return 'Отчет по техобслуживанию транспортных средств, включающий данные о ремонтах, ТО и затратах.';
      case 'violations-report':
        return 'Отчет по нарушениям, включающий информацию о нарушениях правил дорожного движения и SafeDrive.';
      case 'efficiency-report':
        return 'Отчет по эффективности транспортных средств, позволяющий оценить их производительность и экономию ресурсов.';
      case 'cost-analysis':
        return 'Анализ затрат на транспортные средства, включающий расходы на топливо, ремонты и обслуживание.';
      case 'time-analysis':
        return 'Анализ времени движения транспортных средств, позволяющий оптимизировать маршруты и уменьшить время простоя.';
      case 'geofence-report':
        return 'Отчет по геозонам, включающий данные о входах и выходах из заданных зон.';
      case 'alert-report':
        return 'Отчет по уведомлениям, включающий информацию о критических событиях и требующих внимания ситуациях.';
      case 'custom-report':
        return 'Пользовательский отчет, позволяющий создавать и настраивать собственные отчеты на основе выбранных параметров и критериев.';
      default: 
        return 'Выберите отчет для просмотра подробной информации и начала работы.';
    }
  };

  
  const getReportImagePath = (reportType) => {
    switch (reportType) {
      case 'track': 
        return `linear-gradient(135deg, rgba(78, 115, 223, 0.9) 0%, rgba(34, 74, 190, 0.9) 100%), url(${track}) center/cover`;
      case 'live-track': 
        return `linear-gradient(135deg, rgba(54, 185, 204, 0.9) 0%, rgba(26, 137, 151, 0.9) 100%), url(${track}) center/cover`;
      case 'fuel': 
        return `linear-gradient(135deg, rgba(28, 200, 138, 0.9) 0%, rgba(19, 133, 92, 0.9) 100%), url(${fuel}) center/cover`;
      case 'speed': 
        return `linear-gradient(135deg, rgba(246, 194, 62, 0.9) 0%, rgba(221, 162, 10, 0.9) 100%), url(${track2}) center/cover`;
      case 'safedrive-details': 
        return `linear-gradient(135deg, rgba(231, 74, 59, 0.9) 0%, rgba(190, 38, 23, 0.9) 100%), url(${track2}) center/cover`;
      case 'safedrive-rating': 
        return `linear-gradient(135deg, rgba(253, 126, 20, 0.9) 0%, rgba(229, 90, 0, 0.9) 100%), url(${track2}) center/cover`;
      case 'fuel-sheet': 
        return `linear-gradient(135deg, rgba(32, 201, 151, 0.9) 0%, rgba(23, 162, 184, 0.9) 100%), url(${fuel}) center/cover`;
      case 'fuel-delivery': 
        return `linear-gradient(135deg, rgba(40, 167, 69, 0.9) 0%, rgba(30, 126, 52, 0.9) 100%), url(${fuel}) center/cover`;
      case 'fuel-operations': 
        return `linear-gradient(135deg, rgba(23, 162, 184, 0.9) 0%, rgba(19, 132, 150, 0.9) 100%), url(${fuel}) center/cover`;
      case 'routes': 
        return `linear-gradient(135deg, rgba(111, 66, 193, 0.9) 0%, rgba(90, 45, 145, 0.9) 100%), url(${track2}) center/cover`;
      case 'movement': 
        return `linear-gradient(135deg, rgba(0, 123, 255, 0.9) 0%, rgba(0, 86, 179, 0.9) 100%), url(${track}) center/cover`;
      case 'journal': 
        return `linear-gradient(135deg, rgba(108, 117, 125, 0.9) 0%, rgba(84, 91, 98, 0.9) 100%), url(${track2}) center/cover`;
      case 'voltage': 
        return `linear-gradient(135deg, rgba(84, 180, 211, 0.9) 0%, rgba(38, 150, 184, 0.9) 100%), url(${track2}) center/cover`;
      case 'rpm': 
        return `linear-gradient(135deg, rgba(157, 78, 221, 0.9) 0%, rgba(123, 44, 191, 0.9) 100%), url(${track2}) center/cover`;
      case 'statistics': 
        return `linear-gradient(135deg, rgba(23, 162, 184, 0.9) 0%, rgba(19, 132, 150, 0.9) 100%), url(${track2}) center/cover`;
      case 'common_stat': 
        return `linear-gradient(135deg, rgba(102, 16, 242, 0.9) 0%, rgba(82, 13, 194, 0.9) 100%), url(${track2}) center/cover`;
      case 'fuel-consumption': 
        return `linear-gradient(135deg, rgba(25, 135, 84, 0.9) 0%, rgba(20, 108, 67, 0.9) 100%), url(${fuel}) center/cover`;
      case 'mileage-report': 
        return `linear-gradient(135deg, rgba(13, 110, 253, 0.9) 0%, rgba(10, 88, 202, 0.9) 100%), url(${track2}) center/cover`;
      case 'driver-performance': 
        return `linear-gradient(135deg, rgba(220, 53, 69, 0.9) 0%, rgba(176, 42, 55, 0.9) 100%), url(${track2}) center/cover`;
      case 'vehicle-maintenance': 
        return `linear-gradient(135deg, rgba(253, 126, 20, 0.9) 0%, rgba(229, 90, 0, 0.9) 100%), url(${track2}) center/cover`;
      case 'violations-report': 
        return `linear-gradient(135deg, rgba(220, 53, 69, 0.9) 0%, rgba(176, 42, 55, 0.9) 100%), url(${track2}) center/cover`;
      case 'efficiency-report': 
        return `linear-gradient(135deg, rgba(25, 135, 84, 0.9) 0%, rgba(20, 108, 67, 0.9) 100%), url(${track2}) center/cover`;
      case 'cost-analysis': 
        return `linear-gradient(135deg, rgba(255, 193, 7, 0.9) 0%, rgba(224, 168, 0, 0.9) 100%), url(${track2}) center/cover`;
      case 'time-analysis': 
        return `linear-gradient(135deg, rgba(111, 66, 193, 0.9) 0%, rgba(90, 45, 145, 0.9) 100%), url(${track2}) center/cover`;
      case 'geofence-report': 
        return `linear-gradient(135deg, rgba(32, 201, 151, 0.9) 0%, rgba(23, 162, 184, 0.9) 100%), url(${track2}) center/cover`;
      case 'alert-report': 
        return `linear-gradient(135deg, rgba(220, 53, 69, 0.9) 0%, rgba(176, 42, 55, 0.9) 100%), url(${track2}) center/cover`;
      case 'custom-report': 
        return `linear-gradient(135deg, rgba(108, 117, 125, 0.9) 0%, rgba(84, 91, 98, 0.9) 100%), url(${track2}) center/cover`;
      default: 
        return `linear-gradient(135deg, rgba(133, 135, 150, 0.9) 0%, rgba(96, 97, 111, 0.9) 100%), url(${track2}) center/cover`;
    }
  };

  
  const handleReportHover = (reportType) => {
    setPreviewReport({
      title: getReportTitle(reportType),
      description: getReportDescription(reportType),
      image: getReportImagePath(reportType)
    });
  };

  
  const renderReportItem = (reportType, Icon, label) => (
    <li 
      onClick={() => handleReportSelect(reportType)}
      onMouseEnter={() => handleReportHover(reportType)}
    >
      <FontAwesomeIcon icon={Icon} />
      <span>{label}</span>
    </li>
  );

  
  const toggleCompactMode = () => {
    setIsCompactMode(!isCompactMode);
  };

  
  const toggleProfileMenu = (e) => {
    e.stopPropagation();
    setProfileMenuOpen(!profileMenuOpen);
  };

  
  const handleClickOutside = (event) => {
    if (
      profileMenuRef.current && 
      !profileMenuRef.current.contains(event.target) &&
      !event.target.closest('.sidebar-header')
    ) {
      setProfileMenuOpen(false);
    }
  };

  
  const handleLogout = () => {
    
    window.location.href = '/login';
  };

  
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  
  useEffect(() => {
    const createPulseEffect = (element) => {
      
      const existingEffects = element.querySelectorAll('.pulse-effect');
      existingEffects.forEach(effect => effect.remove());

      
      const pulseEffect = document.createElement('div');
      pulseEffect.className = 'pulse-effect';
      element.appendChild(pulseEffect);

      
      setTimeout(() => {
        pulseEffect.remove();
      }, 500);
    };

    
    const navItems = document.querySelectorAll('.nav-item');
    navItems.forEach(item => {
      item.addEventListener('click', function() {
        createPulseEffect(this);
      });
    });

    return () => {
      
      navItems.forEach(item => {
        item.removeEventListener('click', () => {});
      });
    };
  }, []);

  
  useEffect(() => {
    try {
      const updateTimestamp = new Date().getTime(); // Добавляем +5 к timestamp
      localStorage.setItem('lastDateRange', JSON.stringify({
        startDate: dateRange.startDate ? dateRange.startDate.toISOString() : null,
        endDate: dateRange.endDate ? dateRange.endDate.toISOString() : null,
        updateTimestamp
      }));
    } catch (e) {
      console.warn('Не удалось сохранить диапазон дат в localStorage:', e);
    }
  }, [dateRange]);
  
  
  useEffect(() => {
    localStorage.setItem('splitScreenMode', splitMode);
  }, [splitMode]);

  
  const renderReactComponent = (componentType, container, props) => {
    if (!container) return;
    
    try {
      const root = ReactDOM.createRoot(container);
      
      
      switch (componentType) {
        case 'ReportSelector':
          root.render(<ReportSelector 
            selectedVehicle={selectedVehicle} 
            onSelectReport={props.onSelectReport}
            onCancel={props.onCancel}
          />);
          break;
        
        default:
          console.warn('Неизвестный тип компонента:', componentType);
      }
    } catch (error) {
      console.error('Ошибка при рендеринге React компонента:', error);
      container.innerHTML = `<div class="error-message">Ошибка при рендеринге: ${error.message}</div>`;
    }
  };
  
  
  
  const createReportForContainer = (reportType, containerId, vehicleObj, startDateObj, endDateObj) => {
    console.log('Создание отчета:', {
      reportType,
      containerId,
      vehicle: vehicleObj ? vehicleObj.name : 'не указано',
      startDate: startDateObj,
      endDate: endDateObj
    });
    
    // Находим контейнер
    const container = document.getElementById(containerId);
    if (!container) {
      console.error(`Контейнер с ID ${containerId} не найден`);
      return;
    }
    
    // Очищаем контейнер перед добавлением нового отчета
    if (container.firstChild) {
      try {
        container.innerHTML = '';
      } catch (e) {
        console.error('Ошибка при очистке контейнера:', e);
      }
    }
    
    // Создаем элемент для отчета
    try {
      // Создаем новый корень React
      const root = ReactDOM.createRoot(container);
      
      // Получаем компонент для отчета
      const reportElement = getReportElement(reportType, vehicleObj, startDateObj, endDateObj);
      
      // Рендерим компонент в контейнер
      if (reportElement) {
        root.render(reportElement);
        console.log(`Отчет типа ${reportType} создан в контейнере ${containerId}`);
      } else {
        console.error(`Неизвестный тип отчета: ${reportType}`);
        container.innerHTML = `<div class="error-message">Неизвестный тип отчета: ${reportType}</div>`;
      }
    } catch (error) {
      console.error(`Неожиданная ошибка при обработке контейнера ${containerId}:`, error);
    }
  };
  
  
  const reactRoots = useRef(new Map()).current;
  
  
  useEffect(() => {
    return () => {
      
      console.log('ReportsPage: Очистка всех React-корней при размонтировании');
      
      reactRoots.forEach((root, id) => {
        try {
          console.log(`ReportsPage: Размонтирование React-корня для контейнера ${id}`);
          
          root.render(null);
        } catch (e) {
          console.error(`Ошибка при очистке React-корня для контейнера ${id}:`, e);
        }
      });
      
      
      reactRoots.clear();
    };
  }, [reactRoots]);
  
  
  const safelyRemoveReactRoot = (containerId) => {
    const root = reactRoots.get(containerId);
    if (root) {
      try {
        console.log(`ReportsPage: Безопасное удаление React-корня для контейнера ${containerId}`);
        
        root.render(null);
        
        reactRoots.delete(containerId);
        return true;
      } catch (e) {
        console.error(`Ошибка при удалении React-корня для контейнера ${containerId}:`, e);
        return false;
      }
    }
    return false;
  };
  
  
  const renderReportToContainer = (container, reportType, vehicle, startDate, endDate) => {
    if (!container) {
      console.error('ReportsPage: Невозможно отрендерить отчет - контейнер не найден');
      return;
    }
    
    console.log(`ReportsPage: Начинаем рендеринг отчета типа ${reportType} в контейнер ${container.id || 'без ID'}`);
    
    
    if (!container.id) {
      container.id = `chart-container-${Math.random().toString(36).substring(2, 11)}`;
      console.log(`ReportsPage: Присвоен новый ID контейнеру: ${container.id}`);
    }
    
    
    if (reactRoots.has(container.id)) {
      const existingRoot = reactRoots.get(container.id);
      try {
        console.log(`ReportsPage: Удаление существующего React-корня для ${container.id}`);
        existingRoot.render(null); 
        
        
        setTimeout(() => {
          reactRoots.delete(container.id); 
          console.log(`ReportsPage: React-корень для ${container.id} удален из Map`);
        }, 50);
      } catch (e) {
        console.error(`Ошибка при удалении существующего React-корня:`, e);
      }
    }
    
    
    setTimeout(() => {
      try {
        
        if (!document.body.contains(container)) {
          console.error(`ReportsPage: Контейнер ${container.id} больше не присутствует в DOM`);
          return;
        }
        
        
        container.setAttribute('data-react-managed', 'true');
        
        
        const reportElement = getReportElement(reportType, vehicle, startDate, endDate);
        
        if (!reportElement) {
          console.error(`ReportsPage: Не удалось создать элемент отчета типа ${reportType}`);
          container.innerHTML = `
            <div style="padding: 20px; color: #721c24; background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px;">
              <h3>Ошибка при создании отчета</h3>
              <p>Не удалось создать элемент отчета типа ${reportType}</p>
            </div>
          `;
          return;
        }
        
        
        console.log(`ReportsPage: Создание нового React-корня для контейнера ${container.id}`);
        try {
          const root = ReactDOM.createRoot(container);
          
          
          reactRoots.set(container.id, root);
          
          
          root.render(reportElement);
          
          console.log(`Отчет типа ${reportType} успешно создан в контейнере ${container.id}`);
        } catch (error) {
          console.error(`Ошибка при рендеринге отчета в контейнер ${container.id}:`, error);
          
          
          try {
            
            while (container.firstChild) {
              container.removeChild(container.firstChild);
            }
            
            
            const errorDiv = document.createElement('div');
            errorDiv.innerHTML = `
              <div style="padding: 20px; color: #721c24; background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px;">
                <h3>Ошибка при создании отчета</h3>
                <p>${error.message}</p>
                <p>Пожалуйста, попробуйте создать отчет заново или обновите страницу.</p>
              </div>
            `;
            container.appendChild(errorDiv);
          } catch (renderError) {
            console.error(`Не удалось отрендерить сообщение об ошибке:`, renderError);
          }
        }
      } catch (error) {
        console.error(`Неожиданная ошибка при обработке контейнера ${container.id}:`, error);
      }
    }, 100); 
  };
  
  
  const handleSplitModeChange = (mode) => {
    console.log('Изменение режима разделения экрана на:', mode);
    setSplitMode(mode);
  };

  useEffect(() => {
    if (splitMode !== 'single' && !splitScreenActive) {
      handleSplitModeChange(splitMode);
    }
  }, [splitMode, splitScreenActive]);

  const handleDateChange = (start, end) => {
    if (start instanceof Date) {
      start.setHours(0, 0, 0, 0);
    }
    
    setDateRange({
      startDate: start,
      endDate: end
    });
    
    try {
      if (start instanceof Date && end instanceof Date) {
        localStorage.setItem('lastDateRange', JSON.stringify({
          startDate: start.toISOString(),
          endDate: end.toISOString(),
          updateTimestamp: new Date().getTime()
        }));
        
        console.log('Сохранены даты в localStorage (handleDateChange):', {
          startDate: start.toISOString(),
          endDate: end.toISOString()
        });
      }
    } catch (error) {
      console.warn('Ошибка при сохранении дат в localStorage:', error);
    }
    
    if (openTabs.length > 0) {
      setOpenTabs(prevTabs => prevTabs.map(tab => ({
        ...tab,
        startDate: start,
        endDate: end
      })));
      
      console.log('Обновлен диапазон дат для всех отчетов:', {
        startDate: start ? start.toISOString() : 'не указана',
        endDate: end ? end.toISOString() : 'не указана'
      });
    }
  };

  const getReportElement = (reportType, vehicle, startDate, endDate) => {
    const reportProps = {
      key: `split-${reportType}-${vehicle?.id || 'no-vehicle'}-${Date.now()}`,
      vehicle: vehicle,
      startDate: startDate,
      endDate: endDate,
      hidePeriodSelector: true
    };
    
    switch (reportType) {
      case 'track':
        return <TrackReport {...reportProps} />;
      case 'live-track':
        return <LiveTrack {...reportProps} />;
      case 'speed':
        return <SpeedChart {...reportProps} />;
      case 'fuel':
        return <FuelChart {...reportProps} />;
      case 'voltage':
        return <VoltageChart {...reportProps} />;
      case 'rpm':
        return <EngineChart {...reportProps} />;
      case 'statistics':
        return <StatisticsReport {...reportProps} />;
      case 'common_stat':
        return <CommonStatReport {...reportProps} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (selectedVehicle || dateRange.startDate || dateRange.endDate) {
      console.log('ReportsPage: Ключевые параметры изменились, обновляем React-корни');
      
      openTabs.forEach(tab => {
        const containerId = tab.id;
        if (containerId) {
          if (safelyRemoveReactRoot(containerId)) {
            console.log(`ReportsPage: Удален React-корень для вкладки ${tab.title} (${containerId})`);
          }
        }
      });
    }
  }, [selectedVehicle, dateRange, openTabs, safelyRemoveReactRoot]);

  return (
    <div className={`reports-page ${isCompactMode ? 'compact-mode' : ''}`}>
      <div className={`sidebar ${isCompactMode ? 'compact-mode' : ''}`}>
        <div 
                className="sidebar-header" 
                id="sidebarHeader" 
                onClick={toggleProfileMenu}
            >
                <img 
                  src = {logo} 
                  alt="Контроль Техники" 
                  className="logo-image" 
                />
                <h1 className="logo-text">Контроль Техники</h1>
            </div>

        {profileMenuOpen && (
          <div 
          className={`profile-menu ${profileMenuOpen ? 'active' : 'hidden'}`} 
          id="profileMenu" 
          ref={profileMenuRef}
      >
          
          <ul>
              <li className="profile-item">
                  <FontAwesomeIcon icon={faUser} className="profile-icon" />
                  <a href="#" className='profile-text'>ТОО Контроль Техники</a>
              </li>

              <li className="menu-item">
                  <FontAwesomeIcon icon={faFileAlt} className="menu-icon" />
                  <a href="/vehicles">Администрирование</a>
              </li>
              
              <li className="menu-item">
                  <FontAwesomeIcon icon={faQuestion} className="menu-icon" />
                  <a href="#">Руководство пользователя</a>
              </li>
              
              <li className="menu-item">
                  <FontAwesomeIcon icon={faInfo} className="menu-icon" />
                  <a href="#">О программе</a>
              </li>
              
              <li className="menu-item" onClick={handleLogout}>
                  <FontAwesomeIcon icon={faRightFromBracket} className="menu-icon" />
                  <a href="#" id="logout-link">Выход</a>
              </li>
          </ul>
      </div>
        )}

        <div className="sidebar-date-section">
          <div className="date-display">
            <div className="date-label">Период:</div>
            <div className="date-value" onClick={handleCalendarClick}>
              {dateRange.startDate && dateRange.endDate && 
                `${formatDate(dateRange.startDate)} - ${formatDate(dateRange.endDate)}`}
              <FontAwesomeIcon icon={faCalendarAlt} style={{ marginLeft: '8px' }} />
            </div>
          </div>
          
          <div className="period-tabs">
            <div 
              className={`period-tab ${selectedPeriod === 'day' ? 'active' : ''}`}
              onClick={() => handlePeriodChange('day')}
            >
              День
            </div>
            <div 
              className={`period-tab ${selectedPeriod === 'week' ? 'active' : ''}`}
              onClick={() => handlePeriodChange('week')}
            >
              Неделя
            </div>
            <div 
              className={`period-tab ${selectedPeriod === 'month' ? 'active' : ''}`}
              onClick={() => handlePeriodChange('month')}
            >
              Месяц
            </div>
          </div>

          <div className="sidebar-search-box">
            <FontAwesomeIcon icon={faSearch} className="sidebar-search-icon" />
            <input 
              type="text" 
              className="sidebar-search-input" 
              placeholder="Поиск транспортных средств..." 
              id="vehicle-search"
            />
          </div>
        </div>

        {showDateModal && (
          <div className="date-picker-modal">
            <div className="date-picker-content">
              <h3>Выбор периода</h3>
              <div className="date-inputs">
                <div className="form-group">
                  <label htmlFor="start-date">Начальная дата</label>
                  <input
                    id="start-date"
                    type="date"
                    className="form-control"
                    value={tempStartDate}
                    onChange={handleStartDateChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="end-date">Конечная дата</label>
                  <input
                    id="end-date"
                    type="date"
                    className="form-control"
                    value={tempEndDate}
                    onChange={handleEndDateChange}
                  />
                </div>
              </div>
              <div className="date-picker-actions">
                <button className="btn btn-secondary" onClick={closeDateModal}>
                  Отмена
                </button>
                <button className="btn btn-primary" onClick={applyDateRange}>
                  Применить
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="stats-container">
          <div className="stats-header">Статистика</div>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">
                <FontAwesomeIcon icon={faTruck} />
              </div>
              <div className="stat-value">{stats.vehicles}</div>
              <div className="stat-label">Транспорт</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <FontAwesomeIcon icon={faUser} />
              </div>
              <div className="stat-value">{stats.drivers}</div>
              <div className="stat-label">Водители</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </div>
              <div className="stat-value">{stats.trips}</div>
              <div className="stat-label">Рейсы</div>
            </div>
          </div>
        </div>

        <div className="filters-container">
          <div className="filters-header">Статусы</div>
          <div className="filters-grid">
            <div className="filter-bubble" style={{ background: 'linear-gradient(135deg, #1ABC9C 0%, #16A085 100%)' }}>
              <span>0</span>
            </div>
            <div className="filter-bubble" style={{ background: 'linear-gradient(135deg, #E67E22 0%, #D35400 100%)' }}>
              <span>0</span>
            </div>
            <div className="filter-bubble" style={{ background: 'linear-gradient(135deg, #E74C3C 0%, #C0392B 100%)' }}>
              <span>0</span>
            </div>
            <div className="filter-bubble" style={{ background: 'linear-gradient(135deg, #95A5A6 0%, #7F8C8D 100%)' }}>
              <span>0</span>
            </div>
            <div className="filter-bubble" style={{ background: 'linear-gradient(135deg, #3498DB 0%, #2980B9 100%)' }}>
              <span>0</span>
            </div>
          </div>
        </div>

        <div className="sidebar-nav">
          <div className="nav-group">
            <div className="nav-group-title">Транспортные средства</div>
            <FolderList 
              onVehicleSelect={handleVehicleSelect}
            />
          </div>
        </div>

        <div className="sidebar-toggle" onClick={toggleCompactMode}>
          <FontAwesomeIcon icon={isCompactMode ? faAngleRight : faAngleLeft} />
        </div>
      </div>
      
      <div className="main-content">
        <div className="top-bar">
          <div className="report-menu-container">
            <div className="add-report-btn" onClick={handleAddReportClick}>
              <FontAwesomeIcon icon={faPlus} />
              <span>Добавить отчет</span>
            </div>
            
            {showReportMenu && (
              <div className="report-menu-popup" ref={reportMenuRef}>
                <div className="report-menu-columns">
                  <div className="report-column">
                    <h4>Отчеты</h4>
                    <div className="report-list-container">
                      <ul className="report-list">
                        {renderReportItem('safedrive-details', faExclamationTriangle, 'SafeDrive: Детализация нарушений')}
                        {renderReportItem('safedrive-rating', faShieldAlt, 'SafeDrive: Рейтинг водителей')}
                        {renderReportItem('fuel-sheet', faClipboardList, 'Ведомость топливозаправщика')}
                        {renderReportItem('fuel-delivery', faGasPump, 'Выдача топлива')}
                        {renderReportItem('fuel-operations', faGasPump, 'Выдачи, заливы и сливы топлива')}
                        {renderReportItem('routes', faRoad, 'Выполнение рейсов')}
                        {renderReportItem('movement', faCarAlt, 'Движение')}
                        {renderReportItem('journal', faFileAlt, 'Журнал')}
                        {renderReportItem('fuel-events', faGasPump, 'Заправки и сливы')}
                        {renderReportItem('statistics', faChartBar, 'Статистика')}
                        {renderReportItem('common_stat', faChartBar, 'Сводный отчет')}
                        {renderReportItem('fuel-consumption', faGasPump, 'Расход топлива')}
                        {renderReportItem('mileage-report', faRoad, 'Отчет по пробегу')}
                        {renderReportItem('driver-performance', faUser, 'Производительность водителей')}
                        {renderReportItem('vehicle-maintenance', faTruck, 'Техобслуживание')}
                        {renderReportItem('violations-report', faExclamationTriangle, 'Отчет по нарушениям')}
                        {renderReportItem('efficiency-report', faChartLine, 'Отчет по эффективности')}
                        {renderReportItem('cost-analysis', faChartBar, 'Анализ затрат')}
                        {renderReportItem('time-analysis', faTimes, 'Анализ времени')}
                        {renderReportItem('geofence-report', faMapMarkerAlt, 'Отчет по геозонам')}
                        {renderReportItem('alert-report', faBell, 'Отчет по уведомлениям')}
                        {renderReportItem('custom-report', faFileAlt, 'Пользовательский отчет')}
                      </ul>
                    </div>
                  </div>

                  <div className="report-column">
                    <h4>Карта</h4>
                    <ul className="report-list">
                      {renderReportItem('location', faMapMarked, 'Местоположение')}
                      {renderReportItem('track', faRoute, 'Трек')}
                    </ul>
                  </div>

                  <div className="report-column">
                    <h4>Графики</h4>
                    <ul className="report-list">
                      {renderReportItem('tire-pressure', faTachometerAlt, 'Давление в шинах')}
                      {renderReportItem('movement-period', faChartBar, 'Диаграмма: Движение за период')}
                      {renderReportItem('load-period', faChartLine, 'Диаграмма: Нагрузка за период')}
                      {renderReportItem('work-period', faCalendarDay, 'Диаграмма: Работа за период')}
                      {renderReportItem('fuel', faGasPump, 'Объем топлива')}
                      {renderReportItem('speed', faTachometerAlt, 'Скорость')}
                      {renderReportItem('voltage', faChartLine, 'Напряжение бортовой сети')}
                      {renderReportItem('rpm', faChartArea, 'Обороты двигателя')}
                    </ul>
                  </div>

                  <div className="report-column">
                    <h4>Рабочие столы</h4>
                    <ul className="report-list">
                      {renderReportItem('manager-dashboard', faClipboardCheck, 'Рабочий стол Руководителя')}
                      {renderReportItem('track-movement', faRoad, 'Трек + Движение')}
                      {renderReportItem('track-violations', faExclamationTriangle, 'Трек + Нарушения')}
                      {renderReportItem('track-fuel', faGasPump, 'Трек + Объём топлива')}
                    </ul>
                  </div>

                  <div className="report-preview">
                    <div 
                      className="preview-image" 
                      style={{ background: previewReport.image }}
                    ></div>
                    <h3>{previewReport.title}</h3>
                    <div className="preview-description">
                      {previewReport.description}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <div className="report-tabs">
            {openTabs.map(tab => (
              <div 
                key={tab.id}
                className={`report-tab ${activeTabId === tab.id ? 'active' : ''}`}
                onClick={() => handleTabChange(tab.id)}
                data-tab-id={tab.id}
                data-vehicle-id={tab.vehicle?.id}
                data-vehicle-imei={tab.vehicle?.imei}
                data-report-type={tab.type}
              >
                <FontAwesomeIcon icon={getReportIcon(tab.type)} />
                <span>{tab.title}</span>
                <button 
                  className="close-tab"
                  onClick={(e) => handleCloseTab(tab.id, e)}
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
          
          <div className="top-bar-actions">
            <div className="action-button" title="Приложения">
              <FontAwesomeIcon icon={faTh} />
            </div>
            <div className="action-button" title="Уведомления">
              <FontAwesomeIcon icon={faBell} />
              <span className="notification-count">0</span>
            </div>
            <div className="action-button" title="Помощь">
              <FontAwesomeIcon icon={faQuestionCircle} />
            </div>
          </div>
          
        </div>
        
        <div 
          className={`reports-container ${splitScreenActive ? 'split-screen-mode' : ''}`} 
          ref={reportsContainerRef}
        >
          {!splitScreenActive && renderActiveTabContent()}
        </div>
        
        <div 
          id="emergency-exit-fullscreen" 
          style={{ 
            position: 'fixed', 
            bottom: 10, 
            right: 10, 
            zIndex: 10000, 
            background: 'rgba(255,0,0,0.8)', 
            color: 'white', 
            padding: '5px 10px', 
            borderRadius: 5, 
            cursor: 'pointer', 
            display: 'none'
          }}
          onClick={() => window.exitFullscreen && window.exitFullscreen()}
        >
          Выйти из полного экрана
        </div>
      </div>
      
      <ChartDebugPanel />
    </div>
  );
};

export default ReportsPage;